import type { ProductData } from "@/mocks/products";

interface Props {
  product: ProductData;
}

export default function BenefitsSection({ product }: Props) {
  return (
    <section className="py-10 md:py-14">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="mb-8 md:mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2">
              Why Teams Choose {product.name.replace("StackMap ", "")}
            </h2>
            <p className="text-base text-silver-400">
              Tangible outcomes from using this module.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
            {product.benefits.map((benefit) => (
              <div
                key={benefit}
                className="flex items-start gap-3 p-5 rounded-xl bg-graphite-800/60 border border-graphite-700/50"
              >
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-emerald-accent/10 shrink-0 mt-0.5">
                  <i className="ri-check-line text-emerald-accent text-sm" />
                </span>
                <p className="text-sm text-silver-300 leading-relaxed">{benefit}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}